<div class="access-card" [class.expanded]="expanded">
  <div class="card-header" (click)="toggleExpanded()">
    <div class="card-title">
      <div
        class="title-icon"
        [class.success]="successfullyConnected"
        [class.info]="needsCloudFormationMigration || showMigrationDuringTest"
      >
        @if (successfullyConnected) {
          <i class="fa-solid fa-check"></i>
        }
        @if (needsCloudFormationMigration || showMigrationDuringTest) {
          <i class="fa-solid fa-arrow-right-arrow-left"></i>
        }
        @if (
          !successfullyConnected && !needsCloudFormationMigration && !showMigrationDuringTest && accessType === 'source'
        ) {
          <i class="fa-solid fa-location-dot"></i>
        }
        @if (
          !successfullyConnected && !needsCloudFormationMigration && !showMigrationDuringTest && accessType === 'target'
        ) {
          <i class="fa-solid fa-location-crosshairs"></i>
        }
        @if (
          !successfullyConnected &&
          !needsCloudFormationMigration &&
          !showMigrationDuringTest &&
          accessType === 'failback'
        ) {
          <i class="fa-solid fa-rotate-left"></i>
        }
      </div>
      <div>
        <h3>{{ title }}</h3>
        <div class="card-subtitle">
          <code>{{ awsAccountId }}</code> / <code>{{ region }}</code>
        </div>
      </div>
    </div>
    <div class="card-actions">
      <div class="card-action" (click)="$event.stopPropagation()">
        @if (successfullyConnected) {
          <span class="success-badge"><i class="fa-solid fa-circle-check"></i> Connected</span>
        }
        @if (needsCloudFormationMigration || showMigrationDuringTest) {
          <span class="info-badge"><i class="fa-solid fa-circle-info"></i> Action Required</span>
        }
        @if (!successfullyConnected && !needsCloudFormationMigration && !showMigrationDuringTest) {
          <button class="arpio-button" [disabled]="testing" (click)="testButtonClick()">
            @if (testing) {
              <i class="fa-solid fa-spinner fa-spin"></i> TESTING...
            } @else {
              TEST ACCESS
            }
          </button>
        }
      </div>
      <i class="fa-solid chevron-icon" [class.fa-chevron-down]="expanded" [class.fa-chevron-right]="!expanded"></i>
    </div>
  </div>

  <!-- Body: Not connected - needs setup -->
  @if (!successfullyConnected && !needsCloudFormationMigration && !showMigrationDuringTest) {
    <div class="card-body-wrapper" [@slideDown]="expanded ? 'expanded' : 'collapsed'">
      <div class="card-body">
        <p class="instruction-text">
          @if (stackName) {
            @if (retryText && !testing) {
              <strong class="retry-text">{{ retryText }}</strong>
            }
            Update the CloudFormation stack <strong>{{ stackName }}</strong> with this template:
          } @else {
            @if (connectSuccess) {
              @if (retryText && !testing) {
                <strong class="retry-text">{{ retryText }}</strong>
              }
              Update the {{ uiService.productName }} CloudFormation stack with this template:
            } @else {
              @if (retryText && !testing) {
                <strong class="retry-text">{{ retryText }}</strong>
              }
              Create a new CloudFormation stack from this template:
            }
          }
        </p>
        <div class="command-block">
          <button class="copy-btn" [copy-clipboard]="templateUrl" (copied)="onCopied()">
            <i class="fa-utility fa-semibold" [class.fa-copy]="!copied" [class.fa-check]="copied"></i>
            {{ copied ? 'Copied!' : 'Copy URL' }}
          </button>
          <pre><code>{{ templateName }}</code></pre>
        </div>
        <p class="help-text">
          <a [href]="templateUrl" target="_blank" class="download-link">
            <i class="fa-solid fa-download"></i> Download {{ templateName }}
          </a>
        </p>
      </div>
    </div>
  }

  <!-- Body: Needs CloudFormation migration (currently via StackSets) -->
  @if (needsCloudFormationMigration || showMigrationDuringTest) {
    <div class="card-body-wrapper" [@slideDown]="expanded ? 'expanded' : 'collapsed'">
      <div class="card-body">
        <div class="info-message">
          <i class="fa-solid fa-circle-info"></i>
          <span
            >Access is currently provided by StackSets. Deploy this CloudFormation template to switch to standalone
            management.</span
          >
        </div>
        <div class="notice-block">
          <div class="notice-text">
            @if (retryText && !testing) {
              <strong class="retry-text">{{ retryText }}</strong>
            }
            <span>After deploying the CloudFormation template, verify access is configured:</span>
          </div>
          <button class="arpio-button" [disabled]="testing" (click)="testButtonClick()">
            @if (testing) {
              <i class="fa-solid fa-spinner fa-spin"></i> TESTING...
            } @else {
              TEST ACCESS
            }
          </button>
        </div>
        <div class="command-block">
          <button class="copy-btn" [copy-clipboard]="templateUrl" (copied)="onCopied()">
            <i class="fa-utility fa-semibold" [class.fa-copy]="!copied" [class.fa-check]="copied"></i>
            {{ copied ? 'Copied!' : 'Copy URL' }}
          </button>
          <pre><code>{{ templateName }}</code></pre>
        </div>
        <p class="help-text">
          <a [href]="templateUrl" target="_blank" class="download-link">
            <i class="fa-solid fa-download"></i> Download {{ templateName }}
          </a>
        </p>
      </div>
    </div>
  }

  <!-- Body: Successfully connected via CloudFormation -->
  @if (successfullyConnected) {
    <div class="card-body-wrapper" [@slideDown]="expanded ? 'expanded' : 'collapsed'">
      <div class="card-body success-body">
        <div class="success-message">
          <i class="fa-solid fa-circle-check"></i>
          <span>Access configured via CloudFormation</span>
        </div>
      </div>
    </div>
  }
</div>
